
import Dashboard from 'containers/Dashboard'
import Claims from 'scenes/Claims'

const routes = {
  path: '/',
  component: Claims,
  container: Dashboard,
}

export default routes



// WEBPACK FOOTER //
// ./src/routes/claims.js